import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { S } from "@/lib/sessionsApi";
import { getUser } from "@/lib/store";
import { realtime } from "@/lib/realtime";

export const READ_KEY = "itp_chat_read";
export const readMap = () => { try { return JSON.parse(localStorage.getItem(READ_KEY)) || {}; } catch (e) { return {}; } };
export const markRead = (sid, count) => { const r = { ...readMap(), [sid]: count }; localStorage.setItem(READ_KEY, JSON.stringify(r)); window.dispatchEvent(new Event("itp-chat-read")); };

export function useChatNotifications(intervalMs = 6000) {
  const [unread, setUnread] = useState(0);
  const loc = useLocation(), nav = useNavigate();
  const seenLast = useRef(null), path = useRef(loc.pathname);
  path.current = loc.pathname;

  useEffect(() => {
    let stop = false;
    const tick = async () => {
      try {
        const rows = await S.activity();
        if (stop) return;
        const read = readMap(), me = getUser()?.id;
        let total = 0;
        for (const r of rows) {
          const viewing = path.current === `/w/chat/${r.session_id}`;
          if (viewing) { markReadSilently(r.session_id, r.count); continue; }
          total += Math.max(0, r.count - (read[r.session_id] || 0));
          const last = r.last;
          if (last && seenLast.current && seenLast.current[r.session_id] !== last.id && last.from !== me && seenLast.current[r.session_id] !== undefined) {
            const mentioned = last.mentions?.includes(me);
            toast(mentioned ? `${last.name || "Bandmate"} mentioned you · ${r.name}` : `${last.name || "Bandmate"} · ${r.name}`, { description: last.text.slice(0, 140), action: { label: "Open", onClick: () => nav(`/w/chat/${r.session_id}`) }, duration: mentioned ? 10000 : 6000, className: mentioned ? "!border-amber-400" : undefined });
          }
        }
        seenLast.current = Object.fromEntries(rows.map((r) => [r.session_id, r.last?.id ?? null]));
        setUnread(total);
      } catch (e) { /* transient */ }
    };
    const markReadSilently = (sid, count) => { const r = readMap(); if (r[sid] !== count) { r[sid] = count; localStorage.setItem(READ_KEY, JSON.stringify(r)); } };
    tick();
    const t = setInterval(tick, intervalMs);
    let dt = null;
    const onRead = () => { clearTimeout(dt); dt = setTimeout(tick, 600); };
    window.addEventListener("itp-chat-read", onRead);
    const un = realtime.subscribe((d) => { if (d.type === "message") tick(); });
    return () => { stop = true; clearInterval(t); clearTimeout(dt); un(); window.removeEventListener("itp-chat-read", onRead); };
  }, []); // eslint-disable-line
  return unread;
}
